module.exports = __webpack_public_path__ + "img/GAME_CHILGYO2.9b574291.jpg";